'use strict';

module.exports = require('./react-bubble-chart-d3').default;